import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialValues as createInitialValues } from '../pages/MCBOS020/formConfig'
import { initialValues as copyFormValues } from '../pages/MCBOS020/formConfig'
import { initRequest, initResponse } from '../pages/MCBOS020/formConfig'
import { InitialValues } from '../pages/MCBOS020/formConfig'
import { deleteRequest } from '../pages/MCBOS030/formConfig'
import { initUpdateFormValues } from '../pages/MCBOS030/formConfig'
import { MCBOS020CreateRequest } from 'types/MCBOS020/MCBOS020CreateRequest'
import { MCBOS020InitRequest } from 'types/MCBOS020/MCBOS020InitRequest'
import { MCBOS030DeleteRequest } from 'types/MCBOS030/MCBOS030DeleteRequest'
import { MCBOS010InitResponse } from 'types/MCBOS010/MCBOS010InitRequest'
import { MCBOS020InitResponse } from 'types/MCBOS020/MCBOS020InitResponse'

export interface SelectionFileManagement {
  selectionFileManagementId: number
  selectionFilename: string
  displayOrder: number
  updater: string
  updateTime: string
  sysVersionNumber: number
}

export interface InitUpdateFormValues {
  selectionFileName: string;
  targetYear: string;
  selectionFileManagementId: number;
  sysVersionNumber: number;
}

export interface RegisterUpdateValues {
  selectionFileName: string;
  targetYear: string;
  selectionFileManagementId: number;
  sysVersionNumber: number;
}


export interface copyFormValues {
  selectionFileManagementId: string;
  targetYear: string;
  targetYearList: string[];
}


interface InitialValuesType {
  selectionFileManagementList: SelectionFileManagement[]
  createFormValues: MCBOS020CreateRequest
  initFormValues: MCBOS020InitRequest
  initMcbos020: MCBOS020InitResponse
  initUpdateFormValues: InitUpdateFormValues
  copyFormValues: InitialValues
  dialogOpen: boolean
  createDialogOpen: boolean
  updateDialogOpen: boolean
  dialogMessage: string
  deleteFileManagementDataRequest: MCBOS030DeleteRequest
  yearList: string[]
  selectionManagementOptionValidStatus: number
  maxSelectionFileNameCount: string
  batchOperationOptionItemsInfo: string[]
  canAccess: boolean;
  error: string | null;
  initLoading: boolean;
  initInitialized: boolean;
  registerApiLoading: boolean;
  registerApiError: string | null;
  updateApiLoading: boolean;
  updateApiError: string | null;
  copyApiLoading: boolean;
  copyApiError: string | null;
}

const initialState: InitialValuesType = {
  selectionFileManagementList: [],
  createFormValues: createInitialValues,
  initFormValues: initRequest,
  initMcbos020: initResponse,
  initUpdateFormValues: initUpdateFormValues,
  copyFormValues: copyFormValues,
  dialogOpen: false,
  createDialogOpen: false,
  updateDialogOpen: false,
  dialogMessage: '',
  deleteFileManagementDataRequest: deleteRequest,
  yearList: [],
  selectionManagementOptionValidStatus: 0,
  maxSelectionFileNameCount: '',
  batchOperationOptionItemsInfo: [],
  canAccess: false,
  error: null,
  initLoading: false,
  initInitialized: false,
  registerApiLoading: false,
  registerApiError: null,
  updateApiLoading: false,
  updateApiError: null,
  copyApiLoading: false,
  copyApiError: null,
}

const selectionFileManagementSlice = createSlice({
  name: 'selectionFileManagement',
  initialState,
  reducers: {
    fetchInitMCBOS010: (state) => {
      return {
        ...state,
      };
    },
    setInitMCBOS010(
      state,
      action: PayloadAction<MCBOS010InitResponse>
    ) {
      state.selectionManagementOptionValidStatus = action.payload.selectionManagementOptionValidStatus;
      state.maxSelectionFileNameCount = action.payload.maxSelectionFileNameCount;
      state.batchOperationOptionItemsInfo = action.payload.batchOperationOptionItemsInfo;
      state.selectionFileManagementList = action.payload.selectionFileNameItemsInfoList;
      return state;
    },
    updateSelectionFileManagement(
      state,
      action: PayloadAction<{
        selectionFileManagementId: number[]
        year: string
        versionNumber: number[]
      }>
    ) {
      return state
    },
    updateSelectionFileManagementFlagDisplayOrder(
      state,
      action: PayloadAction<SelectionFileManagement[]>
    ) {
      state.selectionFileManagementList = action.payload;
      return state;
    },
    checkRegisterRequest: (state, action: PayloadAction<{
      yearDeterminingMediaFlag: string
    }>) => {
      return state
    },
    checkCopyRequest: (state, action: PayloadAction<{
      id: number,
      versionNumber: number
      yearDeterminingMediaFlag: string
    }>) => {
    	return state
    },
    checkUpdateRequest: (state, action: PayloadAction<{ id: number, versionNumber: number}>) => {
      return state;
    },
    setInit(state,action: PayloadAction<MCBOS020InitRequest>) {
      
      state.initFormValues=action.payload
      return state
    },
    setCopy(state, action: PayloadAction<InitialValues>) {
      state.copyFormValues = action.payload
      return state
    },
    setCreateDialogOpen(
      state,
      action: PayloadAction<boolean>
    ) {
      state.createDialogOpen = action.payload
      return state
    },
    fetchInitMCBOS020: (
      state,
      action: PayloadAction<{yearDeterminingMediaFlag: string }>
    ) => {
      return state;
    },
    setInitMCBOS020(
      state,
      action: PayloadAction<MCBOS020InitResponse>
    ) {
      state.initMcbos020.selectionFileName = action.payload.selectionFileName
      state.initMcbos020.targetYearList = action.payload.targetYearList
      state.initMcbos020.yearDeterminingMediaFlag = action.payload.yearDeterminingMediaFlag
      return state;
    },
    getCreateValues(state) {
      return state
    },
    setCreateValues(state, action: PayloadAction<MCBOS020CreateRequest>) {
      state.createFormValues = action.payload
      return state
    },
    doCreate(state, action: PayloadAction<MCBOS020CreateRequest>) {
      return state
    },
    selectionFileLinkReducer(state, action: PayloadAction<number>) {
      state.initFormValues.selectionFileManagementId = action.payload
      return state
    },
    setUpdateValues(state, action: PayloadAction<InitUpdateFormValues>) {
      state.initUpdateFormValues = action.payload
      return state
    },
    setUpdateDialogOpen(
      state,
      action: PayloadAction<boolean>
    ) {
      state.updateDialogOpen = action.payload
      return state
    },
    doUpdate(state, action: PayloadAction<RegisterUpdateValues>) {
      return state
    },
    doDelete(state, action: PayloadAction<MCBOS030DeleteRequest>) {
      return state
    },
  },
})

export const {
  setInit,
  setCreateDialogOpen,
  fetchInitMCBOS010,
  updateSelectionFileManagement,
  updateSelectionFileManagementFlagDisplayOrder,
  setInitMCBOS010,
  checkRegisterRequest,
  checkUpdateRequest,
  checkCopyRequest,
  fetchInitMCBOS020,
  setInitMCBOS020,
  getCreateValues,
  setCreateValues,
  doCreate,
  doUpdate,
  doDelete,
  setCopy,
  selectionFileLinkReducer,
  setUpdateValues,
  setUpdateDialogOpen,
} = selectionFileManagementSlice.actions
export default selectionFileManagementSlice.reducer
